<template>
  <div :class="className">
    <img v-for="n in repeat" :src="makePath(n)" alt="">
  </div>
</template>

<script>
export default {
  name: 'PictureFrame',
  props: {
    msg: String,
    thumbnail: {
      type: Boolean,
      default: true
    },
    path: String,
    repeat: Number
  },
  computed:  {
    className () {
      return this.thumbnail ? 'js-pict_frame' : 'js-pict_frame_nothmb';
    }
  },
  methods: {
    makePath (num) {
      return `/assets/img/${this.path}${num}.jpg`
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
